import * as yup from 'yup';

export const vibeCheckSettingsSchema = yup.object().shape({
  vibeCheckEnabled: yup.boolean(),
});
